import React, { Component } from 'react'
import { InputSearchLayout, PageContainerLayout, PageHeaderLayout, PaginationLayout } from '../../../layouts'
import { ExtractionsHeaderTiles, ExtractionsTable } from '../../containers'
import { extractionOperations } from '../../../../state/ducks/extractions'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { ExtractionShape, PaginationShape } from '../../../../prop-types'

class ExtractionsPage extends Component {
  constructor (props) {
    super(props)

    this.state = {
      params: {}
    }
    this.fetchExtractions = this.fetchExtractions.bind(this)
    this.onDeleteExtraction = this.onDeleteExtraction.bind(this)
    this.onPaginationChange = this.onPaginationChange.bind(this)
    this.onSearchChange = this.onSearchChange.bind(this)
    this.updateParams = this.updateParams.bind(this)
  }

  UNSAFE_componentWillMount () {
    this.fetchExtractions()
  }

  fetchExtractions () {
    this.props.fetchExtractions(this.state.params)
  }

  onDeleteExtraction (id) {
    this.props.removeExtraction(id)
  }

  onPaginationChange (page) {
    this.updateParams('page', page)
  }

  onSearchChange (keywork) {
    this.updateParams('search', keywork)
  }

  updateParams (key, value) {
    const { params } = this.state
    params[key] = value
    if (key === 'search') {
      params.page = 1
    }
    this.setState({
      params
    }, () => this.fetchExtractions())
  }

  renderHeaderPaths () {
    return (
            <>
                <li>Extractions</li>
            </>
    )
  }

  render () {
    return (
            <>
                <PageContainerLayout clientSidebar={true} showNavbarClientOptions={true}>
                    <PageHeaderLayout title={'Extractions'} subTitle={'All extractions'}
                                      paths={this.renderHeaderPaths}/>
                    {/* Page Content */}
                    <div className="content content-boxed">
                        {/* Header Tiles */}
                        <ExtractionsHeaderTiles all_extractions={this.props.paginationData.totalItems}/>
                        {/* END Header Tiles */}
                        <div className={' block block-themed block-opt-refresh-icon7 ' + (this.props.isLoading ? ' block-opt-refresh ' : '')}>
                            <div className="block-header bg-primary-dark">
                                <ul className="block-options">
                                    <li>
                                        <button type="button" data-toggle="block-option"
                                                data-action="fullscreen_toggle">
                                            <i className="si si-size-fullscreen"/>
                                        </button>
                                    </li>
                                    <li>
                                        <button type="button"
                                                data-toggle="block-option"
                                                data-action="refresh_toggle"
                                                data-action-mode="demo"
                                                onClick={this.fetchExtractions}
                                        >
                                            <i className="si si-refresh"></i>
                                        </button>
                                    </li>
                                </ul>
                                <h3 className="block-title">All extractions</h3>
                            </div>
                            <div className="block-content">
                                {/* Search */}
                                <InputSearchLayout onSearchChange={this.onSearchChange}/>
                                {/* End Search */}
                                {/* Table */}
                                <ExtractionsTable extractions={this.props.extractions} removeExtraction={this.onDeleteExtraction}>
                                    {/* Pagination */}
                                    <PaginationLayout pagination={this.props.paginationData}
                                                      onPaginationChange={this.onPaginationChange}/>
                                    {/* End Pagination */}
                                </ExtractionsTable>
                                {/* End Table */}
                            </div>
                        </div>
                    </div>
                    {/* END Page Content */}
                </PageContainerLayout>
            </>
    )
  };
}

// Set propTypes
const { arrayOf, func } = PropTypes
ExtractionsPage.propTypes = {
  extractions: arrayOf(ExtractionShape).isRequired,
  fetchExtractions: func.isRequired,
  paginationData: PaginationShape
}

// Set defaultProps
ExtractionsPage.defaultProps = {
  extractions: [],
  paginationData: {}
}

// mapStateToProps
const mapStateToProps = (state) => ({
  isLoading: state.extractions.fetchExtractionsReducer.loading,
  extractions: state.extractions.fetchExtractionsReducer.data.results,
  paginationData: state.extractions.fetchExtractionsReducer.data.pagination_data
})

// mapStateToProps
const mapDispatchToProps = {
  fetchExtractions: extractionOperations.list,
  removeExtraction: extractionOperations.remove
}

// Export Class
const _ExtractionsPage = connect(mapStateToProps, mapDispatchToProps)(ExtractionsPage)
export { _ExtractionsPage as ExtractionsPage }
